import { render } from "./ConfirmModal.vue?vue&type=template&id=218ea2d9"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__